export default __webpack_public_path__ + "images/0b2340d40c696eb051de13381b2e2afc-search_sp3_3@2x.png";